module.exports = __webpack_public_path__ + "img/Forma 7.83535e7c.svg";